import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { RawAllowedActionMutations } from "@opstel/query/v2/opstelClient";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery } from "@tanstack/react-query";
import {
  AllowedActionMutations,
  allowedActionMutationsSchema,
} from "@opstel/query/v2/models/allowedActionMutations";

function parseAllowedActionMutations(rawAction: RawAllowedActionMutations): AllowedActionMutations {
  const result = allowedActionMutationsSchema.safeParse(rawAction);
  if (!result.success) {
    console.error(result.error);
    throw result.error;
  }
  return result.data;
}

export function useAllowedActionMutationsQuery({ actionId }: { actionId: string }) {
  const { instanceId } = useCurrentInstanceId();
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: instances.current(instanceId).action(actionId).allowedMutations,
    queryFn: () =>
      opstelClient.getAllowedActionMutations({ instanceId: instanceId ?? "", actionId }),
    select: parseAllowedActionMutations,
  });
}
